<template>
    <div class="download">
        <div class="pc" v-if="equipment == 'pc'">
            <navig :w="w" :only="only" :mask="mask" />
            <img src="~img/Thecore/06.png" class="top_img" />
            <main>
                <ul class="naviga">
                    <li class="active">
                        <span>{{ title }}</span>
                        <div class="active"></div>
                    </li>
                </ul>
                <div class="remark">
                    <p v-html="remark"></p>
                </div>
                <el-table :data="tableData" border style="width: 12.35rem">
                    <el-table-column v-for="(column, index) in columns" :key="column.key" :prop="column.key"
                        :label="column.title" header-align="left" align="left"
                        :min-width="index === 0 ? undefined : '120'" :width="index === 0 ? '200px' : undefined">
                        <template slot-scope="scope">

                            <!-- 普通文本 -->
                            <template v-if="column.type === 'text'">
                                <div class="text-call" v-for="(text, index) in scope.row[column.key]" :key="index">
                                    {{ text.value }}
                                </div>
                            </template>

                            <!-- 链接 -->
                            <template v-else-if="column.type === 'link'">
                                <div class="link-call" v-for="(link, index) in scope.row[column.key]" :key="index">
                                    <a :href="formatUrl(link.value)" target="_blank" rel="noopener noreferrer"
                                        style="color: #2569F6;">
                                        {{ link.key }}
                                    </a>
                                </div>
                            </template>

                        </template>
                    </el-table-column>
                </el-table>

            </main>
            <pc-footer :showFooter="showFooter" />
        </div>



        <div class="web" v-if="equipment == 'web'">
            <webNav v-if="equipment == 'web'" :mask="mask" />
            <div class="top_box"></div>
            <img src="~img/Thecore/12.png" class="top_img" />
            <main>
                <div class="web-title">{{ title }}</div>
                <div class="heng"></div>
                <div class="Introduction" v-html="remark"></div>
                <div class="table-web">
                    <ul v-for="item in webTable">
                        <li v-for="val in item">
                            <div class="label-text">{{ val.label }}</div>
                            <div class="label-value" v-if="val.type === 'text'">
                                <div v-for="text in val.value">{{ text.value }}</div>
                            </div>
                            <div style="padding: 9px 10px;width: 100%;" v-if="val.type === 'link'">
                                <a :href="formatUrl(links.value)" class="label-link" v-for="links in val.value"
                                    style="display: block;">{{
                                        links.key }}</a>
                            </div>
                        </li>
                    </ul>
                    <!-- <ul>
            <li>
              <div class="label-text">Type</div>
              <div class="label-value">IDE</div>
            </li>
            <li>
              <div class="label-text">Tool Name</div>
              <div class="label-value">Arm Keil uVision</div>
            </li>
            <li>
              <div class="label-text">Version</div>
              <div class="label-value">Substituted by MDKv6</div>
            </li>
            <li>
              <div class="label-text">Reference</div>
              <div class="label-value">https://www.keil.com/update/rvmdk.asp</div>
            </li>
          </ul> -->
                </div>
            </main>
            <up />
            <div class="foot">
                <web-footer />
            </div>
        </div>
    </div>
</template>


<script>
import navig from "@/components/navigation.vue"; // pc 导航
import pcFooter from "@/components/pcFooter.vue"; // pc 底部
import webNav from "@/components/webNav.vue"; // web 导航
import webFooter from "@/assembly/web/webFooter.vue"; // web 底部
import $ from "jquery";
import up from "@/components/Backtotop.vue";
export default {
    components: {
        navig,
        pcFooter,
        webNav,
        webFooter,
        up,
    },
    data() {
        return {
            w: undefined,
            equipment: "",
            only: true,
            mask: "NO",
            showFooter: true,
            columns: [],
            tableData: [],
            webTable: [],
            title: '',
            remark: ''
        };
    },
    created() {
        this.w = document.documentElement.offsetWidth || document.body.offsetWidth;
        if (this.w <= 750) {
            this.equipment = "web";
        } else {
            this.equipment = "pc";
        }
        this.infoId = this.getQueryValue("infoId");
        // this.path = decodeURIComponent(this.getQueryValue("path"));
        let params = this.$route.params;
        // console.log(params);
        Object.keys(params).forEach((key) => {
            console.log(params[key]);
            if (params[key] != undefined) {
                this.path.push(params[key]);
            }
        });
        console.log(this.path);
        this.getDetail();
    },
    mounted() {
        window.onresize = () => {
            // 动态检测宽度变化
            return (() => {
                this.w = document.body.clientWidth;
                this.h = document.documentElement.clientHeight; // 视口的高度
                if (this.w <= 750) {
                    this.equipment = "web";
                } else {
                    this.equipment = "pc";
                }
            })();
        };
    },
    methods: {
        initTableData(data) {
            // 解析 columns
            try {
                this.columns = JSON.parse(data.columns || '[]')
            } catch (e) {
                console.error('columns 解析失败：', e)
                this.columns = []
                return
            }

            // 解析 rows
            try {
                const rows = JSON.parse(data.rows || '[]')

                this.tableData = rows.map(row => {
                    const newRow = { ...row }

                    this.columns.forEach(column => {
                        const value = newRow[column.key]

                        // link 类型
                        if (column.type === 'link') {
                            try {
                                newRow[column.key] = JSON.parse(value || '[]')
                            } catch (e) {
                                newRow[column.key] = []
                            }
                        }

                        // text 类型
                        else {
                            newRow[column.key] = String(value || '')
                                .split(/\r?\n/)
                                .filter(item => item.trim() !== '')
                                .map(item => ({
                                    key: '',
                                    value: item.trim()
                                }))
                        }
                    })

                    return newRow
                })
                console.log(this.tableData, '1212121')
            } catch (e) {
                console.error('rows 解析失败：', e)
                this.tableData = []
            }
        },
        webTableData(data) {
            let columns = []
            let rows = []

            try {
                columns = JSON.parse(data.columns || '[]')
                rows = JSON.parse(data.rows || '[]')
            } catch (e) {
                console.error('JSON解析失败', e)
                this.webTable = []
                return
            }

            const result = rows.map(row => {
                return columns.map(column => {
                    let value = row[column.key] || ''

                    // ========================
                    // link 类型
                    // ========================
                    if (column.type === 'link') {
                        try {
                            value = JSON.parse(value || '[]')
                        } catch (e) {
                            console.error(`${column.key} 链接数据解析失败：`, value)
                            value = []
                        }
                    }

                    // ========================
                    // text 类型
                    // ========================
                    else {
                        value = String(value)
                            .split(/\r?\n/)
                            .filter(item => item.trim() !== '')
                            .map(item => ({
                                key: '',
                                value: item.trim()
                            }))
                    }

                    return {
                        label: column.title,
                        value,
                        type: column.type
                    }
                })
            })

            this.webTable = result
        },
        formatUrl(url) {
            if (!url) {
                return ''
            }

            let result = url

            // 处理 Markdown 链接
            const match = result.match(
                /^\[.*?\]\((.*?)\)$/
            )

            if (match) {
                result = match[1]
            }

            // 去除反斜杠
            result = result.replace(/\\/g, '')

            // 自动补充协议
            if (!/^https?:\/\//i.test(result)) {
                result = 'https://' + result
            }

            return result
        },
        async getDetail() {
            const res = await this.axios(
                `/v1/api/corepower_infos_resource?infoId=${this.infoId}`
            );
            console.log(res)
            if (res.code == "00") {
                this.initTableData(res.data[0])
                this.webTableData(res.data[0])
                this.title = res.data[0].title
                this.remark = res.data[0].remark
                console.log(this.webTable)
            } else {
                this.$message.error("数据请求失败");
            }
        },

    },
};
</script>

<style lang="less" scoped>
.download {
    background: #ededed;

    // height: 2000px;
    .pc {
        position: relative;

        .top_img {
            width: 10.75rem
                /* 1075/100 */
            ;
            height: 7.63rem
                /* 763/100 */
            ;
            position: absolute;
            top: 0;
            right: 0;
        }

        main {
            position: relative;
            padding-top: 3.46rem
                /* 346/100 */
            ;
            padding-left: 1.34rem
                /* 134/100 */
            ;
            min-height: 300px;

            .naviga {
                display: flex;
                margin-bottom: 0.28rem
                    /* 49/100 */
                ;

                li {
                    font-size: 0.4rem
                        /* 40/100 */
                    ;
                    font-family: Alibaba PuHuiTi;
                    font-weight: bold;
                    color: #000000;
                    margin-right: 0.76rem
                        /* 76/100 */
                    ;
                    cursor: context-menu;
                    height: 0.7rem
                        /* 60/100 */
                    ;
                    position: relative;

                    .active {
                        width: 0.38rem
                            /* 38/100 */
                        ;
                        height: 3px;
                        background: #2569F6;
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        transform: translate(-50%);
                    }
                }
            }

            .remark {
                width: 12.35rem;

                p {
                    font-size: .22rem;
                    line-height: .30rem;
                    text-align: justifyLeft;
                    color: #000000;
                    font-family: MicrosoftYaHei;
                    margin-bottom: .29rem;
                }
            }

            .el-table {
                border: 1px solid #c2c7d4;
                color: #505050;
                margin-bottom: 0.88rem
                    /* 88/100 */
                ;

                /deep/.has-gutter {
                    tr {
                        background-color: #c2c7d4;
                        font-weight: 400;

                        th {
                            background-color: #e7e8e8;
                            border-bottom: 1px solid #c2c7d4;
                            border-right: 1px solid #c2c7d4;

                            .cell {
                                padding-left: .3rem;
                                padding-right: .3rem;
                            }
                        }
                    }
                }

                /deep/td {
                    border-right: 1px solid #c2c7d4;
                    border-bottom: 1px solid #c2c7d4;
                    //cursor: pointer;
                    cursor: context-menu;

                    .cell {
                        // text-decoration: underline;
                        padding-left: .3rem;
                        padding-right: .3rem;
                        font-size: 12px;
                    }
                }

                /deep/td:hover {
                    // color: #01b2db;

                    .cell {
                        // text-decoration: underline;
                    }
                }

                .link-call {
                    // text-align: left;
                    // padding-left: .2rem;
                }

                .link-call:hover {
                    text-decoration: underline;
                    cursor: pointer;
                    text-decoration-color: #2569F6
                }

                .text-call:hover {
                    color: #2569F6;

                }
            }

            :deep(.el-table .el-table__cell) {
                vertical-align: top;
            }

            .foter_nav {
                position: absolute;
                bottom: 0
                    /* 88/100 */
                ;
                right: 0.82rem
                    /* 82/100 */
                ;

                li {
                    text-align: right;
                    font-size: 0.18rem
                        /* 18/100 */
                    ;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 600;
                    color: #000000;
                    line-height: 40px;
                    cursor: pointer;

                    p {
                        font-size: 0.18rem
                            /* 18/100 */
                        ;
                        font-family: Alibaba PuHuiTi;
                        font-weight: 400;
                        color: #505050;
                        line-height: 40px;
                    }

                    .active_color {
                        color: #01b2db;
                    }
                }
            }
        }
    }

    .web {
        background: #ededed;
        position: relative;

        .top_box {
            height: 50px;
        }

        main {
            padding-left: 24px;
            padding-right: 24px;

            .web-title {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #000000;
                text-align: justifyLeft;
                font-style: normal;
                text-transform: none;
            }

            .heng {
                width: 17px;
                height: 2px;
                background: #2569F6;
                margin-top: 15px;
            }

            .Introduction {
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #000000;
                text-align: justifyLeft;
                font-style: normal;
                text-transform: none;
                margin-top: 15px;
            }

            .table-web {
                margin-top: 21px;

                ul {
                    margin-bottom: 20px;
                    border: 1px solid #BEC4D2;
                    border-bottom: none;

                    li {
                        display: flex;
                        align-items: stretch;
                        border-bottom: 1px solid #BEC4D2;
                        min-height: 35px;

                        .label-text {
                            font-size: 13px;
                            color: #383838;
                            flex: 0 0 100px;
                            width: 100px;
                            display: flex;
                            align-items: top;
                            background: #E7E8E8;
                            padding-left: 20px;
                            box-sizing: border-box;
                            padding-top: 9px;
                        }

                        .label-value {
                            font-size: 12px;
                            color: #383838;
                            flex: 1;
                            min-width: 0;
                            white-space: normal;
                            word-break: break-word;
                            overflow-wrap: break-word;
                            padding: 9px 10px;
                            box-sizing: border-box;
                            padding-left: 19px;
                        }

                        .label-link {
                            font-size: 12px;
                            color: #2569F6;
                            // width: 60%;
                            white-space: normal;
                            word-break: break-word;
                            overflow-wrap: break-word;
                            box-sizing: border-box;
                            padding-left: 10px;
                        }
                    }
                }
            }
        }


        .foot {
            background: #000;
        }
    }
}
</style>
